import { create } from 'zustand';
import type { ComponentType } from 'react';

type TitleIcon = ComponentType<{ size?: number | string; style?: React.CSSProperties }>;

interface PageTitleState {
    /** Title shown in the mobile app header, between the logo and the profile. */
    title: string | null;
    icon: TitleIcon | null;
    setPageTitle: (title: string | null, icon?: TitleIcon | null) => void;
}

/**
 * Lets a page put its title in the app header on mobile. The header lives in
 * the app shell, which doesn't know e.g. which Task Master view is open, so the
 * page publishes it here and clears it when it unmounts.
 */
export const usePageTitleStore = create<PageTitleState>((set) => ({
    title: null,
    icon: null,
    setPageTitle: (title, icon = null) => set({ title, icon }),
}));
